<template>
  <div :class="spinnerClasses" role="status" :aria-label="ariaLabel">
    <div
      class="animate-spin rounded-full border-2 border-solid"
      :class="sizeClasses"
      :style="spinnerStyles"
    />
    <span v-if="showLabel" class="sr-only">{{ ariaLabel }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ISpinnerProps } from './types'

const props = withDefaults(defineProps<ISpinnerProps>(), {
  size: 'default',
  variant: 'default',
  showLabel: true,
  ariaLabel: 'Loading...',
})

const spinnerClasses = computed(() => [
  'inline-flex items-center justify-center',
  {
    'text-primary': props.variant === 'default',
    'text-muted-foreground': props.variant === 'muted',
    'text-destructive': props.variant === 'destructive',
    'text-secondary': props.variant === 'secondary',
  },
])

const sizeClasses = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'h-4 w-4'
    case 'lg':
      return 'h-8 w-8'
    case 'xl':
      return 'h-12 w-12'
    default:
      return 'h-6 w-6'
  }
})

const spinnerStyles = computed(() => {
  const currentColor = props.color || 'currentColor'
  return {
    borderColor: `${currentColor}20`, // 20% opacity
    borderTopColor: currentColor,
    color: props.color || undefined,
  }
})
</script>
